module.exports = "/images/logo_admin.svg?9f2cdfaf9e83cbd63557bb2910ed84e4";